// BottomNav: the mobile presentation of the same NavItem list. Shown under the
// 768px breakpoint; the desktop sidebar is hidden there.

import clsx from 'clsx'
import type { NavItem } from './types'
import css from './BottomNav.module.css'

export type BottomNavProps = {
  items: NavItem[]
  activeId: string
  onSelect: (id: string) => void
  /** Accessible name for the nav landmark. */
  ariaLabel?: string
  className?: string
}

/**
 * Render the bottom navigation bar.
 * @param props - items, selection, select handler.
 * @returns the bottom nav element.
 */
export function BottomNav({ items, activeId, onSelect, ariaLabel = 'Navigation', className }: BottomNavProps) {
  return (
    <nav className={clsx(css.bar, className)} aria-label={ariaLabel}>
      {items.map((item) => {
        const active = item.id === activeId
        return (
          <button
            key={item.id}
            type="button"
            className={clsx(css.item, active && css.active)}
            aria-current={active ? 'page' : undefined}
            onClick={() => { onSelect(item.id) }}
          >
            {item.icon != null && (
              <span className={css.icon}>
                {item.icon}
                {item.badge != null && <span className={css.badge}>{item.badge}</span>}
              </span>
            )}
            <span className={css.label}>{item.label}</span>
          </button>
        )
      })}
    </nav>
  )
}
